import { Currency, CurrencyValue, FiatCurrency } from '@usedapp/core'
import { constants } from 'ethers'

export const dollar = new FiatCurrency('Dollar', '$', 2)

export const ZeroCurrencyValue = (currency: Currency) => new CurrencyValue(currency, constants.Zero)
